import BackButton from '../BackButton';
import Banner from '../../../common/components/Banner';
import CkEditorContent from '../../../common/components/CkEditorContent';
import clsx from 'clsx';
import LanguageSelectionForm from '../../../common/components/LanguageSelectionForm';
import React from 'react';
import { Box, ClickAwayListener, Grid, Paper, Typography } from '@material-ui/core';
import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { GeneralContentStyles } from '../../styles/generalContent';
import { StyledButton } from '../../../common/components/Button';

/** Component for LAYOUT_02: Frank with banner, content container and button */
const GeneralContentLayout2: React.FC<GeneralContentProps> = (props: GeneralContentProps): JSX.Element => {
  const {
    bannerImageEnabled,
    bannerImage,
    backgroundColor,
    buttonText,
    buttonStyle,
    content,
    isICPEnabled,
    schedulableTaskItem,
  } = props;
  const image = bannerImage ? bannerImage.path : '';
  const alt = bannerImage ? bannerImage.name : 'Banner Image';

  const classes = GeneralContentStyles({
    backgroundColor,
    marginTop: '0px',
    isICPEnabled,
    isLanguageSelectionFormOpen: props.isLanguageSelectionFormOpen,
  });

  return (
    <Paper elevation={0} className={classes.bgColorContainer}>
      {bannerImageEnabled && <Banner alt={alt} src={image} />}

      <div
        data-testid="background-frank"
        className={clsx({
          [classes.paperFrank]: true,
          [classes.minGridHeight]: !content || !bannerImage,
          [classes.minCardHeight]: bannerImage,
        })}>
        <Typography variant="srOnly">{`Background Color ${backgroundColor}`}</Typography>

        <Grid container justify="center" className={classes.container}>
          <Grid
            item
            xs={12}
            className={clsx({
              [classes.withoutBannerSpacing]: !bannerImageEnabled,
              [classes.containerJimiFrank]: bannerImageEnabled,
            })}>
            {/** Content Container */}
            <CkEditorContent
              content={content}
              pageStartTime={props.pageStartTime}
              generalContentName={props.name}
              taskName={props.taskName}
            />

            {/** Button */}
            <Box width="100%" textAlign="center" className={classes.gridButton}>
              <StyledButton
                buttonText={buttonText}
                buttonStyle={buttonStyle}
                disabled={props.loading || props.isNextButtonDisabled}
                onClickHandler={props.saveNGetNextWfItem}
              />
              {props.isLanguageSelectionFormOpen && !schedulableTaskItem && (
                <ClickAwayListener onClickAway={props.handleClickAwayLanguageSelection}>
                  <Box className={classes.languageSelectionOverlay}>
                    <Box textAlign="left" className={classes.languageSelectionModal}>
                      <LanguageSelectionForm languages={props.languages} onLanguageSubmit={props.onLanguageSubmit} />
                    </Box>
                  </Box>
                </ClickAwayListener>
              )}
              {props.returnToTaskList && <BackButton />}
            </Box>
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
};

export default GeneralContentLayout2;
